import React, { useEffect, useState } from "react";
import { Input, Descriptions, Divider, Switch } from "antd";
import TicketModelPopup from "../../../../components/modelpopup/TicketModelPopup";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import { Tooltip } from "react-tooltip";
import { Table } from "antd";
import { RightOutlined, DownOutlined } from "@ant-design/icons";
import { MdKeyboardVoice } from "react-icons/md";
import { FaPlus, FaMinus } from "react-icons/fa";

import { useSelector } from "react-redux";
import {
  formatNumbers,
  getDate,
  sumArrayProperties,
} from "../../../../utils/openformat/numbers";
import { useTranslation } from "react-i18next";

import DeleteModal from "../../../../components/modelpopup/deletePopup";
import { Link } from "react-router-dom";
import BbFilter from "../../../../components/BbFilter";
export default function BbBeforePost() {
  const { t } = useTranslation();
  const [data, setData] = useState([]);

  useEffect(() => {
    const raw = localStorage.getItem("expensesData");
    if (raw) {
      try {
        const parsed = JSON.parse(raw);
        const enriched = parsed.map((entry, index) => ({
          key: index,
          ...entry,
        }));
        setData(enriched);
        console.log("Enriched? ", enriched);
      } catch (e) {
        console.error("Failed to parse expensesData:", e);
      }
    }
  }, []);

  const columns = [
    {
      title: "اسم المستند",
      dataIndex: "document_name",
      key: "document_name",
    },
    {
      title: "نوع المستند",
      dataIndex: ["invoice_receipt_details", "document_type"],
      key: "document_type",
    },
    {
      title: "رقم المستند",
      dataIndex: ["invoice_receipt_details", "invoice_number"],
      key: "invoice_number",
    },
    {
      title: "تاريخ المستند",
      dataIndex: ["invoice_receipt_details", "date"],
      key: "date",
    },
    {
      title: "المورد",
      dataIndex: ["invoice_receipt_details", "supplier"],
      key: "supplier",
    },
    {
      title: "المبلغ المستحق",
      dataIndex: ["invoice_receipt_details", "total_due"],
      key: "total_due",
    },
    {
      title: "مدقق",
      key: "audited",
      render: (_, record) => (
        <Switch
          className="btn-switch"
          checked={record.invoice_receipt_details?.audited}
          onChange={(checked) => {
            // Optional: handle toggle logic here
            console.log(`Switched ${record.key} to ${checked}`);
          }}
        />
      ),
    },
  ];

  const expandedRowRender = (record) => {
    const invoice = record.invoice_receipt_details || {};
    const bank = record.bank_transfer_details || {};

    return (
      <div className="details-table expanded-content animate-expand  p-4 rounded-2">
        <Descriptions title="تفاصيل الفاتورة" bordered size="small" column={2}>
          {Object.entries(invoice)
            .filter(([key]) => key !== "invoice_number" && key !== "date")
            .map(([key, value]) => {
              if (Array.isArray(value)) return null;
              return (
                <Descriptions.Item key={key} label={key}>
                  {value || "-"}
                </Descriptions.Item>
              );
            })}
        </Descriptions>

        {Array.isArray(invoice.items) && invoice.items.length > 0 && (
          <>
            <Divider orientation="left">العناصر</Divider>
            <Table
              dataSource={invoice.items.map((item, i) => ({ ...item, key: i }))}
              columns={[
                { title: "رقم الصنف", dataIndex: "item_number" },
                { title: "الوصف", dataIndex: "description" },
                { title: "الكمية", dataIndex: "quantity" },
                { title: "سعر الوحدة", dataIndex: "unit_price_ils" },
                { title: "الإجمالي", dataIndex: "total_ils" },
              ]}
              pagination={false}
              size="small"
            />
          </>
        )}

        {Array.isArray(invoice.payment_details) &&
          invoice.payment_details.length > 0 && (
            <>
              <Divider orientation="left">تفاصيل الدفع</Divider>
              <Table
                dataSource={invoice.payment_details.map((p, i) => ({
                  ...p,
                  key: i,
                }))}
                columns={[
                  { title: "التفاصيل", dataIndex: "line_details" },
                  { title: "نوع الدفع", dataIndex: "payment_type" },
                  { title: "تاريخ الدفع", dataIndex: "payment_date" },
                  { title: "المبلغ", dataIndex: "amount_ils" },
                ]}
                pagination={false}
                size="small"
              />
            </>
          )}

        <Divider orientation="left">تفاصيل التحويل البنكي</Divider>
        <Descriptions bordered size="small" column={2}>
          {Object.entries(bank).map(([key, value]) => (
            <Descriptions.Item key={key} label={key}>
              {value || "-"}
            </Descriptions.Item>
          ))}
        </Descriptions>
      </div>
    );
  };

  return (
    <>
      <div className="page-wrapper">
        {/* Page Content */}
        <div className="content container-fluid">
          {/* Page Header */}
          <Breadcrumbs
            maintitle={t("transactions")}
            title={t("dashboard")}
            subtitle={t("transactions")}
            modal="#add_ticket"
            name="Add Transaction"
          />

          {/* <TicketFilter /> */}
          <div className="row">
            {/* Render the table with the filtered data */}
            {/* <Table columns={fColumns} dataSource={displayData2} /> */}
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-4 m-b-20">
                      {/* <img src={Applogo} className="inv-logo" alt="Logo" /> */}
                      <ul className="list-unstyled mb-0">
                        <li>
                          <span className="text-primary"> الشركة:</span>{" "}
                          Fintrack Demo
                        </li>
                        {/* <li className='text-primary'>{companyData.taxFileNumber}</li> */}
                        {/* <li> {type40Data.companyNumber}</li> */}
                        <li>
                          <span className="text-primary"> المستخدم: </span>
                          DemoUser
                        </li>
                      </ul>
                    </div>
                    <div className="col-sm-5 m-b-20">
                      <ul className="list-unstyled mb-0 text-center">
                        <li>
                          <h3 className="text-primary">BookBot</h3>
                        </li>

                        <li>
                          {" "}
                          <span className="text-primary">قيود شهر :</span>{" "}
                          8-2025
                        </li>
                        <li>
                          {" "}
                          <span className="text-primary">
                            رقم الشركة :
                          </span>{" "}
                          5199999999
                        </li>
                      </ul>
                    </div>
                    <div className="col-sm-3 m-b-20">
                      <ul className="list-unstyled mb-0 text-start">
                        <li dir="">
                          <span className="text-primary" dir="rtl">
                            {" "}
                            Modal type:
                          </span>
                          MassAi
                        </li>
                        <li>
                          <span className="text-primary">
                            {" "}
                            تصدير القيد الى:{" "}
                          </span>
                          <a
                            className="link "
                            href="https://mass-billing.web.app/"
                            target="_blank"
                            title="go to Massbill"
                          >
                            {" "}
                            MassBill
                          </a>
                        </li>

                        {/* <li> {companyData.taxFileNumber} </li> */}
                        {/* <li> {type40Data.phoneNumber}</li> */}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-body">
              <ul className="nav nav-tabs nav-tabs-solid nav-justified bookbot-tabs">
                <li className="nav-item">
                  <Link
                    className="nav-link active"
                    to="#basictab1"
                    data-bs-toggle="tab"
                  >
                    معاينة الملفات
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="#basictab2"
                    data-bs-toggle="tab"
                  >
                    <i className="la la-upload la-lg me-2"></i>
                    تحميل مستندات
                  </Link>
                </li>

                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="#basictab3"
                    data-bs-toggle="tab"
                  >
                    More...
                  </Link>
                </li>

                {/* <li className="nav-item">
                          <Link
                            className="nav-link"
                            data-bs-toggle="modal"
                            data-bs-target="#ai-agent"
                            // data-bs-toggle="tab"
                          >
                            مساعد AI
                          </Link>
                        </li> */}
              </ul>
            </div>

            {/* {prompt && <AiGemelAgent prompt={prompt} />} */}
          </div>
          <BbFilter />
          <div className="tab-content">
            <div className="tab-pane show active" id="basictab1">
              <div className="card">
                <div className="card-header border-0  ">
                  <h3 className="card-title mb-2 text-center text-primary mt-2">
                    تفاصيل الملف{" "}
                  </h3>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    {/* <Table
                      columns={columns}
                      dataSource={data}
                      expandable={{
                        expandedRowRender,
                      }}
                      pagination={{ pageSize: 10 }}
                    /> */}
                    <Table
                      columns={columns}
                      dataSource={data}
                      expandable={{
                        expandedRowRender,
                        expandIcon: ({ expanded, onExpand, record }) =>
                          expanded ? (
                            <>
                              <FaMinus
                                onClick={(e) => onExpand(record, e)}
                                data-tooltip-id={`expand-tip-${record.key}`}
                                data-tooltip-content="إخفاء التفاصيل"
                                style={{ cursor: "pointer", marginRight: 8 }}
                                className="ant-table-row-expand-icon border-none"
                              />
                              <Tooltip
                                id={`expand-tip-${record.key}`}
                                place="bottom"
                                style={{ zIndex: "100" }}
                              />
                            </>
                          ) : (
                            <>
                              <FaPlus
                                onClick={(e) => onExpand(record, e)}
                                data-tooltip-id={`expand-tip-${record.key}`}
                                data-tooltip-content="عرض التفاصيل"
                                className="ant-table-row-expand-icon"
                                style={{
                                  cursor: "pointer",
                                  marginRight: 8,
                                }}
                              />
                              <Tooltip
                                id={`expand-tip-${record.key}`}
                                place="left"
                                style={{ zIndex: "100" }}
                              />
                            </>
                          ),
                      }}
                      pagination={{ pageSize: 10 }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="tab-pane" id="basictab2">
              <div className="card">
                <div className="card-header border-bottom-0 mt-2">
                  <h2 className="text-primary card-title text-center pt-2">
                    فحص ملفات ضريبية
                  </h2>
                </div>
                <div className="card-body"></div>
              </div>
            </div>
            <div className="tab-pane" id="basictab3">
              <div className="card">
                <div className="card-header">
                  <h1 className="text-primary  text-center p-4">
                    Wait For MAssAI 2027
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <TicketModelPopup />
      <DeleteModal Name="Delete Ticket" />
    </>
  );
}
